import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.port.status');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-kreonet-port-status',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonet.port.status/view.scss */
/* src/app/portal.kreonet.port.status/view.scss: no such file or directory */`],
})
export class PortalKreonetPortStatusComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PortalKreonetPortStatusComponent;